import { render, staticRenderFns } from "./farmingMap.vue?vue&type=template&id=2c0d7840&scoped=true"
import script from "./farmingMap.vue?vue&type=script&lang=js"
export * from "./farmingMap.vue?vue&type=script&lang=js"
import style0 from "./farmingMap.vue?vue&type=style&index=0&id=2c0d7840&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0d7840",
  null
  
)

export default component.exports